module.exports = __webpack_public_path__ + "static/media/Trackling_Thumbnail.0b29ed9b.png";